var map = {
	"./collect.png": "47f0",
	"./credit.png": "53c9",
	"./credit_active.png": "428c",
	"./erwei.png": "8749",
	"./erwei_active.png": "d25b",
	"./fapiao.png": "b223",
	"./fapiao_active.png": "2c43",
	"./fence.png": "7de5",
	"./fence_active.png": "206d",
	"./geren.png": "af49",
	"./geren_active.png": "dbf9",
	"./kefu.png": "4d12",
	"./kefu_active.png": "8c1d",
	"./my.png": "4379",
	"./my_active.png": "2e83",
	"./order.png": "08f9",
	"./order_acrive.png": "cce1",
	"./pop.png": "25e9",
	"./pop1.png": "e4bf",
	"./pop2.png": "580c",
	"./pop3.png": "81a3",
	"./shezhi.png": "5511",
	"./shezhi_active.png": "ae23",
	"./tongji.png": "c711",
	"./tongji_active.png": "1963",
	"./unCollect.png": "19dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f1d";